export default __webpack_public_path__ + "static/media/recaas-landing-page-logo-1.4f78f7aa.png";